import { useMemo } from "react";
import type { ChatMessage } from "../types";

type VisibleChatMessage = Pick<ChatMessage, "role" | "content" | "_streaming">;

function isEmptyStreamingAssistantMessage(message: VisibleChatMessage) {
  return (
    message.role === "assistant" &&
    message._streaming &&
    !message.content?.trim()
  );
}

export function useVisibleChatMessages<TMessage extends VisibleChatMessage>(
  messages: TMessage[],
  thinkingSteps: unknown[],
) {
  const hasThinkingSteps = thinkingSteps.length > 0;

  return useMemo(
    () =>
      messages.filter(
        (message) =>
          !(isEmptyStreamingAssistantMessage(message) && hasThinkingSteps),
      ),
    [messages, hasThinkingSteps],
  );
}
